'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var React = require('react');
var styledComponents = require('styled-components');
var nthHookSettings = require('@narvar/nth-hook-settings');

var _templateObject;
var Styled = styledComponents.createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (props) {
  return props.styles;
});
var GlobalStyleTag = function GlobalStyleTag() {
  var _useSettings = nthHookSettings.useSettings(),
    globalScopeCSS = _useSettings.globalScopeCSS;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (globalScopeCSS || []).map(function (globalStyle, index) {
    return /*#__PURE__*/React.createElement(Styled, {
      styles: globalStyle,
      key: index
    });
  }));
};
var index = nthHookSettings.withSettingsProvider(GlobalStyleTag, {
  settingsRequested: 'globalScopeCSS'
});

exports.default = index;
